import { MenuEntry } from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'

const configLimited: (t: ContextApi['t']) => MenuEntry[] = (t) => [
  {
    label: 'HOME',
    icon: 'Home',
    href: '/limited/home',
  },
  {
    label: 'CARD APPLICATION',
    icon: 'Cart',
    href: '/limited/cardapplication',
    disabled: false,
  },
  {
    label: 'WINNING RESULT',
    icon: 'Correct',
    href: '/limited/winningResult',
    disabled: false,
  },
  {
    label: 'CARD BOX',
    icon: 'Box',
    href: '/limited/cardBox',
    disabled: false,
  },
  {
    label: 'POWER',
    icon: 'Airdrop',
    href: '/limited/power',
    disabled: false,
  },
]

export default configLimited
